import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Watchlist, BenchmarkPortfolio, PortfolioType } from '../monitoring.model';

@Injectable({ providedIn: 'root' })
export class WatchlistStore {
  private readonly activeWatchlistSubject = new BehaviorSubject<Watchlist | null>(null);
  private readonly activeBenchmarkSubject = new BehaviorSubject<BenchmarkPortfolio | null>(null);
  private readonly activeSectionSubject = new BehaviorSubject<PortfolioType>('watchlist');
  private loadingStates: { [id: number]: boolean } = {};

  readonly activeWatchlist$ = this.activeWatchlistSubject.asObservable();
  readonly activeBenchmark$ = this.activeBenchmarkSubject.asObservable();
  readonly activeSection$ = this.activeSectionSubject.asObservable();

  setActiveWatchlist(watchlist: Watchlist | null): void {
    this.activeWatchlistSubject.next(watchlist);
    if (watchlist) {
      this.activeSectionSubject.next('watchlist');
      this.activeBenchmarkSubject.next(null);
    }
  }

  setActiveBenchmark(benchmark: BenchmarkPortfolio | null): void {
    this.activeBenchmarkSubject.next(benchmark);
    if (benchmark) {
      this.activeSectionSubject.next('benchmark');
      this.activeWatchlistSubject.next(null);
    }
  }

  setActiveSection(section: PortfolioType): void {
    this.activeSectionSubject.next(section);
    if (section === 'watchlist') {
      this.activeBenchmarkSubject.next(null);
    } else {
      this.activeWatchlistSubject.next(null);
    }
  }

  setWatchlistLoading(watchlistId: number, isLoading: boolean): void {
    this.loadingStates[watchlistId] = isLoading;
  }

  setBenchmarkLoading(benchmarkId: number, isLoading: boolean): void {
    this.loadingStates[benchmarkId] = isLoading;
  }

  isWatchlistLoading(watchlistId: number): boolean {
    return this.loadingStates[watchlistId] || false;
  }

  isBenchmarkLoading(benchmarkId: number): boolean {
    return this.loadingStates[benchmarkId] || false;
  }

  isAnyWatchlistLoading(): boolean {
    return Object.values(this.loadingStates).some(loading => loading);
  }

  getCurrentActiveWatchlist(): Watchlist | null {
    return this.activeWatchlistSubject.value;
  }

  getCurrentActiveBenchmark(): BenchmarkPortfolio | null {
    return this.activeBenchmarkSubject.value;
  }

  getCurrentActiveSection(): PortfolioType {
    return this.activeSectionSubject.value;
  }

  getCurrentActivePortfolio(): Watchlist | BenchmarkPortfolio | null {
    const section = this.getCurrentActiveSection();
    if (section === 'watchlist') {
      return this.getCurrentActiveWatchlist();
    } else {
      return this.getCurrentActiveBenchmark();
    }
  }
}



